import { FC } from "react";
import PortfolioContainer from "./PortfolioContainer";
import { CmpDataPortfolioProps } from "./PortfolioTypes";

interface PortfolioProps {
  content: CmpDataPortfolioProps;
}

const Portfolio: FC<PortfolioProps> = ({ content }) => {
  return (
    <section className="flex w-full flex-col  rounded-xl bg-white px-[16px] py-[12px]">
      {content?.mainHeading && (
        <h2 className="font-medium text-[#1A1A1A] text-[20px]">
          {content.mainHeading ?? "Your Portfolio"}
        </h2>
      )}
      <PortfolioContainer cmpData={content} className="px-0 py-0" />
    </section>
  );
};

export default Portfolio;